import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
import type { User } from "./sharedTypes"

export type AcceptInviteRequest = {
  firstName: string
  lastName: string
  phone: string | null
  password: string
}

export const acceptInvite = async (
  inviteToken: string,
  params: AcceptInviteRequest
) => {
  const { body } = await api.post<User>(
    `/invites/${inviteToken}/accept/`,
    {
      body: params,
    }
  )

  queryClient.invalidateQueries([CURRENT_USER_QUERY_KEY])
  queryClient.invalidateQueries([USERS_QUERY_KEY])
  queryClient.invalidateQueries([CURRENT_TENANT_QUERY_KEY])

  return body
}
